'use strict';
import { module } from "../app";
import Cropper from 'cropperjs';

module.directive("angularCropper", function ($rootScope, $window, $animate) {
  return {
    restrict: "E",
    templateUrl: "views/templates/angularCropper.html",
    scope: {
      settings: "=",
    },
    require: '?ngModel',
    link: function (scope, element, ngModel) {
      if (!scope.settings) {
        return;
      }

      scope.fileURL = URL.createObjectURL(scope.settings.file);
      scope.cropper = null;

      scope.cropperOptions = {
        responsive: true,
        autoCropArea: 1,
        viewMode: 2,
        background: false,
        ready: () => {
          if (scope.croppedData) {
            scope.cropper.setData(scope.croppedData);
          }
        },
      }

      scope.cropperTarget = null;
      scope.croppedData = scope.settings && scope.settings.file && scope.settings.croppedData;

      scope.onImageLoaded = ($event) => {
        scope.cropperTarget = $event.currentTarget;
        scope.cropper = new Cropper(scope.cropperTarget, scope.cropperOptions);
        if (scope.settings.isIOS) {
          document.querySelector('.rotate-btn.rotate-up').addEventListener('touchstart', () => {
            scope.startRotate(1);
          });
          document.querySelector('.rotate-btn.rotate-up').addEventListener('touchend', () => {
            scope.cancelRotate();
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('touchstart', () => {
            scope.startRotate(-1);
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('touchend', () => {
            scope.cancelRotate();
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('contextmenu', ($event) => {
            scope.absorbEvent($event);
          });
          document.querySelector('.rotate-btn.rotate-up').addEventListener('contextmenu', ($event) => {
            scope.absorbEvent($event);
          });
        }
        else {
          document.querySelector('.rotate-btn.rotate-up').addEventListener('mousedown', () => {
            scope.startRotate(1);
          });
          document.querySelector('.rotate-btn.rotate-up').addEventListener('mouseup', () => {
            scope.cancelRotate();
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('mousedown', () => {
            scope.startRotate(-1);
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('mouseup', () => {
            scope.cancelRotate();
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('mouseleave', () => {
            scope.cancelRotate();
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('mouseleave', () => {
            scope.cancelRotate();
          });
          document.querySelector('.rotate-btn.rotate-down').addEventListener('contextmenu', ($event) => {
            scope.absorbEvent($event);
          });
          document.querySelector('.rotate-btn.rotate-up').addEventListener('contextmenu', ($event) => {
            scope.absorbEvent($event);
          });
        }
      }

      scope.settings.getSaveObject = () => {
        return new Promise((resolve, reject) => {
          scope.cropper.getCroppedCanvas().toBlob(blob => {
            const saveObject = {
              croppedBlob: blob,
              fileURL: URL.createObjectURL(blob),
              canvasData: scope.cropper.getData(),
              croppedData: scope.cropper.getCropBoxData(),
            };
            resolve(saveObject);
          });
        });
      }

      scope.changeMode = (mode) => {
        scope.selectionMode = mode;
        let cropMode = null;
        if (scope.selectionMode === 0) {
          cropMode = "crop";
          scope.cropperOptions.cropBoxResizable = false;
        }
        else if (scope.selectionMode === 1) {
          cropMode = "move";
          scope.cropperOptions.cropBoxResizable = true;
        }
        scope.selectionMode = mode;

        scope.croppedData = scope.cropper.getData();
        scope.cropperOptions.ready = () => {
          scope.cropper.setData(scope.croppedData);
          cropMode && scope.cropper.setDragMode(cropMode);
        };
        scope.cropper.destroy();
        scope.cropper = new Cropper(scope.cropperTarget, scope.cropperOptions);
      }


      if (scope.croppedData) {
        scope.rotate = scope.croppedData.rotate;
        scope.previousRotate = scope.rotate;
      }
      else {
        scope.rotate = 0;
        scope.previousRotate = 0;
      }

      scope.rotateImage = (value) => {
        let rotateValue = parseInt((scope.rotate || 0)) + (value || 0);
        if (rotateValue >= 360 ){
          rotateValue -= 360;
        }
        if (rotateValue <= -360 ){
          rotateValue += 360;
        }
        scope.rotate = rotateValue;
      }

      scope.rotateEnabled = false;
      scope.rotateInterval = null;
      scope.rotateTimeout = null;
      scope.startRotate = (value) => {
        scope.rotateImage(value);
        scope.rotateTimeout = setTimeout(() => {
          scope.rotateInterval = setInterval(() => {
            scope.rotateImage(value);
          }, 50);
        }, 500);
      }

      scope.cancelRotate = () => {
        clearTimeout(scope.rotateTimeout);
        clearInterval(scope.rotateInterval);
      }

      scope.absorbEvent = (e) => {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
      }

      scope.$watch('rotate', function (newValue) {
        if (!scope.cropper) {
          return;
        }

        const rotate = scope.cropper.getData().rotate;
        let newValueInt = parseInt(newValue);

        if (newValueInt >= 360 ){
          newValueInt -= 360;
        }
        else if (newValueInt <= -360 ){
          newValueInt += 360;
        }

        scope.cropper.rotate((newValueInt || 0) - rotate);
        scope.previousRotate = newValueInt;

        if (!isNaN(newValueInt)){
          scope.rotate = newValueInt;
        }
      }, true);

      scope.onImageLoadedloadFromExistingData = (imageData) => {
        scope.file = imageData;
        scope.fileURL = URL.createObjectURL(this.file.originalFile);
        return this;
      }
    }
  };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/angularCropper.js